<template>
  <div
    class="wall-item"
    :class="{ isHovered: wall.hovered, isSelected: wall.selected }"
    @mouseenter="hoverWall(true)"
    @mouseleave="hoverWall(false)"
  >
    <div
      class="content"
      @click="selectWall()"
    >
      <div
        v-if="!isEditingName"
        class="name"
        @dblclick="editingWallName"
      >
        {{ wallName }}
      </div>
      <input
        v-else
        class="name-field"
        v-model="wallName"
        @click="e => e.stopPropagation()"
        ref="nameField"
      />
    </div>
    <div class="tools">
      <button
        v-if="!isEditingName"
        class="btn btn-remove"
        @click="removeWall()"
      >
        <TrashIcon class="icon" />
      </button>
      <button
        v-if="isEditingName"
        class="btn btn-save-name"
        @click="saveWallName()"
      >
        <SaveIcon class="icon" />
      </button>
      <button
        v-if="isEditingName"
        class="btn btn-cancel-name"
        @click="cancelWallName()"
      >
        <CancelIcon class="icon" />
      </button>
    </div>
  </div>
</template>

<script>
import TrashIcon from './TrashIcon.vue'
import SaveIcon from './SaveIcon.vue'
import CancelIcon from './CancelIcon.vue'

export default {
  name: 'wall-item',
  components: {
    TrashIcon,
    SaveIcon,
    CancelIcon,
  },
  props: {
    wall: Object,
    walls: Array,
  },
  data() {
    return {
      wallName: this.wall.name,
      isEditingName: false,
    }
  },
  watch: {
    isEditingName: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.nameField.focus()
        })
      }
    },
  },
  methods: {
    removeWall() {
      this.$emit('remove-wall', this.wall.id)
    },
    selectWall() {
      this.$emit('select-wall', this.wall.id, true)
    },
    hoverWall(hovered) {
      this.$emit('hover-wall', this.wall.id, hovered)
    },
    editWallName() {
      this.isEditingName = false
      console.log('ok')
    },
    editingWallName() {
      this.$emit('select-wall', this.wall.id, false)
      this.isEditingName = true
    },
    saveWallName() {
      this.isEditingName = false
      this.$emit('update-wall-name', this.wall.id, this.wallName)
      this.$emit('select-wall', this.wall.id, true)
    },
    cancelWallName() {
      this.wallName = this.wall.name
      this.isEditingName = false
      this.$emit('select-wall', this.wall.id, true)
    },
  },
}
</script>

<style scoped lang="scss">
.wall-item {
  display: flex;
  border: 1px solid transparent;

  &.isHovered {
    border-color: #0d99ff;
  }

  &.isSelected {
    border-color: #0d99ff;
    background-color: #0d99ff22;
  }

  &:hover {
    .tools {
      opacity: 1;
    }
  }
}

.content {
  flex: 1;
  display: flex;
}

.name {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 4px 10px;
  cursor: pointer;
}

.name-field {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 4px 10px;
}

.tools {
  display: flex;
  align-items: center;
  opacity: 0;
  transition: 0.3s;
}

.btn {
  display: inline-flex;
  align-items: center;
  height: 100%;
  background-color: transparent;
  border: none;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0 2px;
}

.btn-remove {
  &:hover {
    .icon {
      color: red;
    }
  }
}

.btn-save-name,
.btn-cancel-name {
  &:hover {
    .icon {
      opacity: 0.5;
    }
  }
}

.icon {
  transition: 0.3s;
}
</style>
